// File: data/customers.js
import img1 from '../assets/images/our_customer/1.png';
import img2 from '../assets/images/our_customer/alpla.png';
import img3 from '../assets/images/our_customer/3.png';
import img4 from '../assets/images/our_customer/4.png';
import img5 from '../assets/images/our_customer/5.png';
import img6 from '../assets/images/our_customer/6.png';
import img7 from '../assets/images/our_customer/7.png';
import imgFrystalPetPrivateLimited from '../assets/images/our_customer/frystal-pet-private-limited.png';
import img11 from '../assets/images/our_customer/11.png';
import img12 from '../assets/images/our_customer/12.png';
import img13 from '../assets/images/our_customer/13.png';
import img14 from '../assets/images/our_customer/14.png';
import img15 from '../assets/images/our_customer/15.png';
import img16 from '../assets/images/our_customer/16.png';
import img17 from '../assets/images/our_customer/17.png';
import img18 from '../assets/images/our_customer/18.png';
import img19 from '../assets/images/our_customer/19.png';
import img20 from '../assets/images/our_customer/20.png';
import img21 from '../assets/images/our_customer/21.png';
import img22 from '../assets/images/our_customer/22.png';
import img23 from '../assets/images/our_customer/23.png';
import img24 from '../assets/images/our_customer/24.png';
import img25 from '../assets/images/our_customer/25.png';
import img27 from '../assets/images/our_customer/27.png';
import imgNational from '../assets/images/our_customer/national.png';
import imgVishalBeveragesPvtLtd from '../assets/images/our_customer/vishal-beverages-pvt-ltd.png';
import imgKaneEMIndustriesLimited from '../assets/images/our_customer/kane-em-industries-limited.jpg';
import imgMoonBeveragesLimited from '../assets/images/our_customer/moon-beverages-limited.png';
import imgCocacola from '../assets/images/our_customer/cococola.png';
import imgParle from '../assets/images/our_customer/parle.png';
import imgPepsi from '../assets/images/our_customer/pepsi.png';
import imgReliance from '../assets/images/our_customer/reliance.png';
import imgRJCorp from '../assets/images/our_customer/rjcorp.jpeg';
import imgDabur from '../assets/images/our_customer/dabur.png';
import imgI2 from '../assets/images/our_customer/i2.jpg';
import imgMagpet from '../assets/images/our_customer/magpet.jpg';
import imgI5 from '../assets/images/our_customer/i5.jpg';
import imgI6 from '../assets/images/our_customer/i6.jpg';
import imgI7 from '../assets/images/our_customer/i7.jpg';
import imgI71 from '../assets/images/our_customer/i71.jpg';
import imgCampa from '../assets/images/our_customer/campa.jpeg';
import imgDentex from '../assets/images/our_customer/dentex.jpeg';
import imgBidco from '../assets/images/our_customer/bidco.jpeg';
import imgBevco from '../assets/images/our_customer/bevco.png';
import imgJambo from '../assets/images/our_customer/jambogroup.jpeg';
import imgKiri from '../assets/images/our_customer/kiri.jpeg';
import imgFuture from '../assets/images/our_customer/futuregroup.jpeg';
import imgSVC from '../assets/images/our_customer/svc.jpeg';
import imgAfricaCrowns from '../assets/images/our_customer/africa-crowns-&-packaging.jpeg';

// Additional imports for new companies (c1 to c29 from your logo grid)
import imgC1 from '../assets/images/our_customer/a-one-products-and-bottlers-limited.png';
import imgC2 from '../assets/images/our_customer/c2.png';
import imgC3 from '../assets/images/our_customer/c3.png';
import imgC4 from '../assets/images/our_customer/c4.png';
import imgC5 from '../assets/images/our_customer/c5.png';
import imgC6 from '../assets/images/our_customer/c6.png';
import imgC7 from '../assets/images/our_customer/c7.png';
import imgC8 from '../assets/images/our_customer/c8.png';
import imgC9 from '../assets/images/our_customer/c9.png';
import imgC10 from '../assets/images/our_customer/c10.png';
import imgC11 from '../assets/images/our_customer/c11.png';
import imgC12 from '../assets/images/our_customer/c12.png';
import imgC13 from '../assets/images/our_customer/c13.png';
import imgC14 from '../assets/images/our_customer/anjani-food-beverages-lda.png';
import imgC15 from '../assets/images/our_customer/c15.png';
import imgC16 from '../assets/images/our_customer/c16.png';
import imgC17 from '../assets/images/our_customer/c17.png';
import imgC20 from '../assets/images/our_customer/c20.png';
import imgC21 from '../assets/images/our_customer/c21.png';
import imgAscent from '../assets/images/our_customer/ascent.png';
import imgC23 from '../assets/images/our_customer/c23.png';
import imgC24 from '../assets/images/our_customer/c24.png';
import imgC25 from '../assets/images/our_customer/c25.png';
import imgC26 from '../assets/images/our_customer/c26.png';
import imgC27 from '../assets/images/our_customer/c27.png';
import imgC28 from '../assets/images/our_customer/c28.png';
import imgC29 from '../assets/images/our_customer/ahmedi-industries-me.png';
import imgSKJCleanEnviro from '../assets/images/our_customer/skj-cleanenviro.png';
import imgGaneshaEcosphereLtd from '../assets/images/our_customer/ganesha-ecosphere-ltd.jpeg';
import imgC33 from '../assets/images/our_customer/c33.png';
import imgC34 from '../assets/images/our_customer/c34.jpg';
import imgC35 from '../assets/images/our_customer/c35.svg';
import imgC36 from '../assets/images/our_customer/c36.png';

import imgC37 from '../assets/images/our_customer/c37.jpeg';
import imgVarunVBL from '../assets/images/our_customer/varun-vbl.png';
const customers = [
  {
    id: 1009,
    title: "Africa Crowns & Packaging",
    slug: "africa-crowns-packaging",
    shortDescription: "Africa Crowns & Packaging - Closures & packaging",
    description: "Africa Crowns & Packaging supplies crown caps and packaging solutions across Africa.",
    image: imgAfricaCrowns,
    isFeatured: true,
    displayOrder: 1
  },

  {
    id: 64,
    title: "Ahmedi Industries ME",
    slug: "ahmedi-industries-me",
    shortDescription: "Ahmedi Industries ME - Middle East industrial solutions",
    description: "Ahmedi Industries ME is a leading industrial company in the Middle East region, providing comprehensive solutions across various manufacturing sectors.",
    image: imgC29,
    isFeatured: true,
    displayOrder: 2
  },

  {
    id: 26,
    title: "Alpla",
    slug: "alpla",
    shortDescription: "Alpla - Global packaging solutions",
    description: "Alpla is a world leader in the development and production of plastic packaging solutions, specializing in bottles, caps, and tubes for various industries.",
    image: img2,
    isFeatured: true,
    displayOrder: 3
  },

  {
    id: 49,
    title: "Anjani Food & Beverages LDA",
    slug: "anjani-food-beverages-lda",
    shortDescription: "Anjani Food & Beverages LDA - Food & beverage solutions",
    description: "Anjani Food & Beverages LDA provides comprehensive solutions for the food and beverage industry including packaging and processing.",
    image: imgC14,
    isFeatured: true,
    displayOrder: 4
  },

  {
    id: 36,
    title: "A ONE PRODUCTS AND BOTTLERS LIMITED",
    slug: "a-one-products-and-bottlers-limited",
    shortDescription: "A ONE PRODUCTS AND BOTTLERS LIMITED - Quality & Excellence Solutions",
    description: "A ONE PRODUCTS AND BOTTLERS LIMITED provides quality and excellence solutions across various industrial sectors with a focus on innovation and customer satisfaction.",
    image: imgC1,
    isFeatured: true,
    displayOrder: 5
  },

  {
    id: 57,
    title: "Ascent",
    slug: "ascent",
    shortDescription: "Ascent - Growth-oriented solutions",
    description: "Ascent offers growth-oriented solutions and services across various industries with a focus on innovation and excellence.",
    image: imgAscent,
    isFeatured: true,
    displayOrder: 6
  },

  {
    id: 35,
    title: "Balaji Polymers",
    slug: "balaji-polymers",
    shortDescription: "Balaji Polymers - Innovative plastic solutions",
    description: "Balaji Polymers specializes in manufacturing high-quality plastic products and polymers for diverse industrial applications.",
    image: img3,
    isFeatured: true,
    displayOrder: 7
  },

  {
    id: 34,
    title: "Bericap",
    slug: "bericap",
    shortDescription: "Bericap - Leading closure manufacturer",
    description: "Bericap is one of the world's leading manufacturers of plastic closures, providing innovative and sustainable packaging solutions.",
    image: img4,
    isFeatured: true,
    displayOrder: 8
  },

  {
    id: 2008,
    title: "Bevco",
    slug: "bevco",
    shortDescription: "Bevco - Beverage company",
    description: "Bevco is a beverage company and new customer logo addition.",
    image: imgBevco,
    isFeatured: true,
    displayOrder: 9
  },

  {
    id: 1002,
    title: "Bidco Africa",
    slug: "bidco-africa",
    shortDescription: "Bidco Africa - Consumer goods",
    description: "Bidco Africa is a leading consumer goods manufacturer across Africa.",
    image: imgBidco,
    isFeatured: true,
    displayOrder: 10
  },

  {
    id: 51,
    title: "Big Tree Zambia",
    slug: "big-tree-zambia",
    shortDescription: "Big Tree Zambia - Entertainment industry leader",
    description: "Big Tree Zambia is a leading company in the entertainment industry, known for innovative solutions and services.",
    image: imgC16,
    isFeatured: true,
    displayOrder: 11
  },

  {
    id: 72,
    title: "Bisleri",
    slug: "bisleri",
    shortDescription: "Bisleri - Beverage company",
    description: "Bisleri is a leading beverage company known for bottled water, soft drinks, and refreshing beverage products.",
    image: imgI71,
    isFeatured: true,
    displayOrder: 12
  },

  {
    id: 55,
    title: "Calco Polychem",
    slug: "calco-polychem",
    shortDescription: "Calco Polychem - Polymer solutions",
    description: "Calco Polychem specializes in polymer solutions and chemical products for various industrial applications.",
    image: imgC20,
    isFeatured: true,
    displayOrder: 13
  },

  {
    id: 1000,
    title: "Campa Cola",
    slug: "campa-cola",
    shortDescription: "Campa Cola - Beverage brand",
    description: "Campa Cola is a beverage brand.",
    image: imgCampa,
    isFeatured: true,
    displayOrder: 14
  },

  {
    id: 70,
    title: "Chemco",
    slug: "chemco",
    shortDescription: "Chemco - Chemical industry specialist",
    description: "Chemco specializes in chemical industry solutions and provides high-quality packaging for chemical products.",
    image: imgI6,
    isFeatured: true,
    displayOrder: 15
  },

  {
    id: 71,
    title: "Chiripal",
    slug: "chiripal",
    shortDescription: "",
    description: "",
    image: imgI7,
    isFeatured: true,
    displayOrder: 16
  },

  {
    id: 3,
    title: "Coca-Cola",
    slug: "coca-cola",
    shortDescription: "Coca-Cola - Global beverage company",
    description: "Coca-Cola is a global leader in the beverage industry, known for its iconic products and packaging innovations.",
    image: imgCocacola,
    isFeatured: true,
    displayOrder: 17
  },

  {
    id: 4,
    title: "Coca-Cola Franchise",
    slug: "coca-cola-franchise",
    shortDescription: "Coca-Cola Franchise - Regional bottling partner",
    description: "Coca-Cola Franchise operates as a regional bottling partner providing distribution and packaging services.",
    image: imgI5,
    isFeatured: true,
    displayOrder: 18
  },

  {
    id: 2010,
    title: "Dabur",
    slug: "dabur",
    shortDescription: "Dabur - Consumer healthcare brand",
    description: "Dabur is a leading consumer healthcare and personal care company with a global presence.",
    image: imgDabur,
    isFeatured: true,
    displayOrder: 19
  },

  {
    id: 44,
    title: "Delta El Nile Egypt",
    slug: "delta-el-nile-egypt",
    shortDescription: "Delta El Nile Egypt - Regional industrial leader",
    description: "Delta El Nile Egypt is a leading industrial company serving the Middle East and North Africa region with diverse solutions.",
    image: imgC9,
    isFeatured: true,
    displayOrder: 20
  },

  {
    id: 1001,
    title: "Dentex Industries Ltd",
    slug: "dentex-industries-ltd",
    shortDescription: "Dentex Industries Ltd - Packaging and closures",
    description: "Dentex Industries Ltd provides packaging and closure solutions for multiple industries.",
    image: imgDentex,
    isFeatured: true,
    displayOrder: 21
  },

  {
    id: 66,
    title: "Devyani",
    slug: "devyani",
    shortDescription: "Devyani - Food service solutions",
    description: "Devyani specializes in food service solutions and packaging for the restaurant and hospitality industry.",
    image: imgI2,
    isFeatured: true,
    displayOrder: 22
  },

  {
    id: 32,
    title: "Epitome",
    slug: "epitome",
    shortDescription: "Epitome - Premium packaging solutions",
    description: "Epitome offers high-quality packaging solutions with a focus on innovation and sustainability for various industries.",
    image: img5,
    isFeatured: true,
    displayOrder: 23
  },

  {
    id: 6,
    title: "FlexiTuff Ventures",
    slug: "flexituff-ventures",
    shortDescription: "FlexiTuff Ventures - Flexible packaging specialists",
    description: "FlexiTuff Ventures is a leading manufacturer of flexible intermediate bulk containers and packaging solutions for diverse industrial applications.",
    image: img6,
    isFeatured: true,
    displayOrder: 24
  },

  {
    id: 40,
    title: "Flotek Botswana",
    slug: "flotek-botswana",
    shortDescription: "Flotek Botswana - Flow technology solutions",
    description: "Flotek Botswana provides advanced flow technology solutions and equipment for various industrial processes.",
    image: imgC5,
    isFeatured: true,
    displayOrder: 25
  },

  {
    id: 7,
    title: "Fresh Pet",
    slug: "fresh-pet",
    shortDescription: "Fresh Pet - Quality pet food packaging",
    description: "Fresh Pet specializes in innovative packaging solutions for the pet food industry, ensuring product freshness and quality.",
    image: img7,
    isFeatured: true,
    displayOrder: 26
  },

  {
    id: 8,
    title: "Frystal Pet Private Limited",
    slug: "frystal-pet-private-limited",
    shortDescription: "Frystal Pet Private Limited - Specialized PET solutions",
    description: "Frystal Pet Private Limited offers specialized PET solutions and packaging products with a focus on quality and sustainability.",
    image: imgFrystalPetPrivateLimited,
    isFeatured: true,
    displayOrder: 27
  },

  {
    id: 1006,
    title: "Future Group",
    slug: "future-group",
    shortDescription: "Future Group - Industrial beverages",
    description: "Future Group specializes in beverage manufacturing and packaging.",
    image: imgFuture,
    isFeatured: true,
    displayOrder: 28
  },

  {
    id: 2002,
    title: "Ganesha Ecosphere Ltd.",
    slug: "ganesha-ecosphere-ltd",
    shortDescription: "Ganesha Ecosphere Ltd. - Packaging / manufacturing",
    description: "Ganesha Ecosphere Ltd. provides packaging and manufacturing solutions with a focus on sustainable operations and customer value.",
    image: imgGaneshaEcosphereLtd,
    isFeatured: true,
    displayOrder: 29
  },

  {
    id: 46,
    title: "Hana KSA",
    slug: "hana-ksa",
    shortDescription: "Hana KSA - Innovative packaging systems",
    description: "Hana KSA specializes in innovative packaging systems and solutions for various industries with a focus on sustainability.",
    image: imgC11,
    isFeatured: true,
    displayOrder: 31
  },

  {
    id: 41,
    title: "Hariss International Uganda",
    slug: "hariss-international-uganda",
    shortDescription: "Hariss International Uganda - Engineering excellence",
    description: "Hariss International Uganda delivers engineering excellence through innovative solutions and high-quality products for industrial applications.",
    image: imgC6,
    isFeatured: true,
    displayOrder: 32
  },

  {
    id: 45,
    title: "IFFCO Dubai",
    slug: "iffco-dubai",
    shortDescription: "IFFCO Dubai - Fertilizer industry leader",
    description: "IFFCO Dubai is one of the world's largest fertilizer cooperatives, providing agricultural solutions and packaging services.",
    image: imgC10,
    isFeatured: true,
    displayOrder: 34
  },

  {
    id: 10,
    title: "Indorama Ventures",
    slug: "indorama-ventures",
    shortDescription: "Indorama Ventures - Global chemical producer",
    description: "Indorama Ventures is a global chemical producer and a leading manufacturer of PET and fibers serving major customers in diversified end markets.",
    image: imgC7,
    isFeatured: true,
    displayOrder: 35
  },

  {
    id: 12,
    title: "IntePac",
    slug: "intepac",
    shortDescription: "IntePac - Integrated packaging solutions",
    description: "IntePac provides integrated packaging solutions for various industries with a focus on innovation and sustainability.",
    image: img12,
    isFeatured: true,
    displayOrder: 36
  },

  {
    id: 1004,
    title: "Jambo Group",
    slug: "jambo-group",
    shortDescription: "Jambo Group - Beverage & packaging",
    description: "Jambo Group is involved in beverage production and related packaging services.",
    image: imgJambo,
    isFeatured: true,
    displayOrder: 37
  },

  {
    id: 30,
    title: "KANE – EM Industries Limited",
    slug: "kane-em-industries-limited",
    shortDescription: "KANE – EM Industries Limited - Industrial manufacturing",
    description: "KANE – EM Industries Limited specializes in industrial manufacturing and provides solutions across various sectors.",
    image: imgKaneEMIndustriesLimited,
    isFeatured: true,
    displayOrder: 38
  },

  {
    id: 37,
    title: "Kiboko Tanzania",
    slug: "kiboko-tanzania",
    shortDescription: "Kiboko Tanzania - Industrial solutions provider",
    description: "Kiboko Tanzania specializes in providing comprehensive industrial solutions and services for diverse manufacturing requirements.",
    image: imgC2,
    isFeatured: true,
    displayOrder: 39
  },

  {
    id: 1005,
    title: "Kiri Bottling Company",
    slug: "kiri-bottling",
    shortDescription: "Kiri Bottling Company - Bottling",
    description: "Kiri Bottling Company supplies bottling and packaging solutions.",
    image: imgKiri,
    isFeatured: true,
    displayOrder: 40
  },

  {
    id: 68,
    title: "Magpet",
    slug: "magpet",
    shortDescription: "Magpet - PET packaging solutions",
    description: "Magpet provides PET packaging solutions and related products for the beverage and packaging industry.",
    image: imgMagpet,
    isFeatured: true,
    displayOrder: 41
  },

  {
    id: 11,
    title: "Mihan",
    slug: "mihan",
    shortDescription: "Mihan - Innovative packaging solutions",
    description: "Mihan offers innovative packaging solutions with a focus on quality and customer satisfaction.",
    image: img11,
    isFeatured: true,
    displayOrder: 42
  },

  {
    id: 60,
    title: "MM Agrawal Group",
    slug: "mm-agrawal-group",
    shortDescription: "MM Agrawal Group - Diversified industrial group",
    description: "MM Agrawal Group is a diversified industrial group offering solutions across multiple sectors including packaging and manufacturing.",
    image: imgC25,
    isFeatured: true,
    displayOrder: 43
  },

  {
    id: 38,
    title: "Mohinani Group",
    slug: "mohinani-group",
    shortDescription: "Mohinani Group - Advanced manufacturing solutions",
    description: "Mohinani Group offers advanced manufacturing solutions and technologies for various industrial applications.",
    image: imgC3,
    isFeatured: true,
    displayOrder: 44
  },

  {
    id: 31,
    title: "Moon Beverages Limited",
    slug: "moon-beverages-limited",
    shortDescription: "Moon Beverages Limited - Authorized bottler",
    description: "Moon Beverages Limited is an authorized bottler of The Coca-Cola Company, serving regional beverage markets with trusted distribution and packaging operations.",
    image: imgMoonBeveragesLimited,
    isFeatured: true,
    displayOrder: 45
  },

  {
    id: 2009,
    title: "National",
    slug: "national",
    shortDescription: "National - Packaging and industrial solutions",
    description: "National provides packaging and industrial solutions focused on quality, reliability, and customer satisfaction.",
    image: imgNational,
    isFeatured: true,
    displayOrder: 46
  },

  {
    id: 48,
    title: "Olympus",
    slug: "olympus",
    shortDescription: "Olympus - Advanced technology solutions",
    description: "Olympus provides advanced technology solutions and equipment for various industrial and scientific applications.",
    image: imgC13,
    isFeatured: true,
    displayOrder: 47
  },

  {
    id: 13,
    title: "Pancham Industries",
    slug: "pancham-industries",
    shortDescription: "Pancham Industries - Diverse industrial solutions",
    description: "Pancham Industries offers a wide range of industrial solutions and products for various manufacturing sectors.",
    image: img13,
    isFeatured: true,
    displayOrder: 48
  },

  {
    id: 33,
    title: "Parle Agro",
    slug: "parle-agro",
    shortDescription: "Parle Agro - Leading food and beverage company",
    description: "Parle Agro is one of India's leading food and beverage companies, known for its innovative products and packaging solutions.",
    image: imgParle,
    isFeatured: true,
    displayOrder: 49
  },

  {
    id: 2011,
    title: "Pepsi",
    slug: "pepsi",
    shortDescription: "Pepsi - Beverage brand",
    description: "Pepsi is a beverage brand and an important customer logo in the portfolio.",
    image: imgPepsi,
    isFeatured: true,
    displayOrder: 50
  },

  {
    id: 47,
    title: "Pentagon Nigeria",
    slug: "pentagon-nigeria",
    shortDescription: "Pentagon Nigeria - Multi-sector solutions",
    description: "Pentagon Nigeria offers comprehensive solutions across multiple sectors including packaging, manufacturing, and industrial services.",
    image: imgC12,
    isFeatured: true,
    displayOrder: 51
  },

  {
    id: 14,
    title: "PFL",
    slug: "pfl",
    shortDescription: "PFL - Plastic fabrication leaders",
    description: "PFL is a leader in plastic fabrication and manufacturing, providing custom solutions for diverse applications.",
    image: img14,
    isFeatured: true,
    displayOrder: 52
  },

  {
    id: 58,
    title: "Plenco Closures",
    slug: "plenco-closures",
    shortDescription: "Plenco Closures - Specialized closure solutions",
    description: "Plenco Closures specializes in manufacturing high-quality closures and caps for various packaging applications.",
    image: imgC23,
    isFeatured: true,
    displayOrder: 52
  },

  {
    id: 2005,
    title: "Poddar",
    slug: "poddar",
    shortDescription: "Poddar - Packaging / manufacturing",
    description: "Poddar - added to customers list (SVG).",
    image: imgC35,
    isFeatured: true,
    displayOrder: 53
  },

  {
    id: 62,
    title: "Polytank",
    slug: "polytank",
    shortDescription: "Polytank - Storage solutions specialist",
    description: "Polytank specializes in storage solutions and tank manufacturing for various industrial and commercial applications.",
    image: imgC27,
    isFeatured: true,
    displayOrder: 54
  },

  {
    id: 15,
    title: "Polytech Plastics",
    slug: "polytech-plastics",
    shortDescription: "Polytech Plastics - Advanced plastic solutions",
    description: "Polytech Plastics specializes in advanced plastic solutions for various industries, with a focus on innovation and quality.",
    image: img15,
    isFeatured: true,
    displayOrder: 55
  },

  {
    id: 52,
    title: "PRAN Group Bangladesh",
    slug: "pran-group-bangladesh",
    shortDescription: "PRAN Group Bangladesh - Food processing leader",
    description: "PRAN Group Bangladesh is a leading food processing company offering a wide range of food products and packaging solutions.",
    image: imgC17,
    isFeatured: true,
    displayOrder: 56
  },

  {
    id: 39,
    title: "Prima Corp Nigeria",
    slug: "prima-corp-nigeria",
    shortDescription: "Prima Corp Nigeria - Premium packaging solutions",
    description: "Prima Corp Nigeria specializes in premium packaging solutions with a focus on quality, innovation, and environmental sustainability.",
    image: imgC4,
    isFeatured: true,
    displayOrder: 57
  },

  {
    id: 16,
    title: "Pury Group",
    slug: "pury-group",
    shortDescription: "Pury Group - Comprehensive industrial solutions",
    description: "Pury Group offers comprehensive industrial solutions across various sectors, with a focus on quality and customer satisfaction.",
    image: img16,
    isFeatured: true,
    displayOrder: 58
  },

  {
    id: 5,
    title: "Reliance Industries",
    slug: "reliance-industries",
    shortDescription: "Reliance Industries - Conglomerate with diverse interests",
    description: "Reliance Industries is one of India's largest conglomerates with interests in various sectors including petrochemicals and packaging.",
    image: imgReliance,
    isFeatured: true,
    displayOrder: 59
  },

  {
    id: 2006,
    title: "RJ Corp",
    slug: "rj-corp",
    shortDescription: "RJ Corp - Packaging & related services",
    description: "RJ Corp - added to customers list.",
    image: imgRJCorp,
    isFeatured: true,
    displayOrder: 60
  },

  {
    id: 59,
    title: "Roha Pack",
    slug: "roha-pack",
    shortDescription: "Roha Pack - Comprehensive packaging",
    description: "Roha Pack offers comprehensive packaging solutions with a focus on innovation, quality, and customer satisfaction.",
    image: imgC24,
    isFeatured: true,
    displayOrder: 61
  },

  {
    id: 63,
    title: "Rungta",
    slug: "rungta",
    shortDescription: "Rungta - Industrial manufacturing",
    description: "Rungta is involved in industrial manufacturing and provides solutions across various sectors with a focus on quality and innovation.",
    image: imgC28,
    isFeatured: true,
    displayOrder: 62
  },

  {
    id: 61,
    title: "Santosh",
    slug: "santosh",
    shortDescription: "Santosh - Industrial solutions provider",
    description: "Santosh provides comprehensive industrial solutions and services with a focus on quality and customer satisfaction.",
    image: imgC26,
    isFeatured: true,
    displayOrder: 63
  },

  {
    id: 17,
    title: "Savera Group",
    slug: "savera-group",
    shortDescription: "Savera Group - Engineering solutions provider",
    description: "Savera Group is a leading engineering solutions provider, offering innovative products and services for various industries.",
    image: img17,
    isFeatured: true,
    displayOrder: 64
  },

  {
    id: 1008,
    title: "Seven Up Bottling Company",
    slug: "seven-up-bottling-company",
    shortDescription: "Seven Up Bottling Company - Beverage manufacturer",
    description: "Seven Up Bottling Company operates bottling facilities and beverage distribution.",
    image: imgSVC,
    isFeatured: true,
    displayOrder: 65
  },

  {
    id: 2004,
    title: "SGS",
    slug: "sgs",
    shortDescription: "SGS - Inspection, verification and testing",
    description: "SGS - added to customers list.",
    image: imgC34,
    isFeatured: true,
    displayOrder: 66
  },

  {
    id: 18,
    title: "Shree Haina",
    slug: "shree-haina",
    shortDescription: "Shree Haina - Quality manufacturing solutions",
    description: "Shree Haina specializes in quality manufacturing solutions with a focus on innovation and customer satisfaction.",
    image: img18,
    isFeatured: true,
    displayOrder: 67
  },

  {
    id: 2001,
    title: "SKJ CleanEnviro",
    slug: "skj-cleanenviro",
    shortDescription: "SKJ CleanEnviro - Environmental solutions",
    description: "SKJ CleanEnviro - empowering circular growth.",
    image: imgSKJCleanEnviro,
    isFeatured: true,
    displayOrder: 68
  },

  {
    id: 19,
    title: "SLMG Beverages",
    slug: "slmg-beverages",
    shortDescription: "SLMG Beverages - Premium beverage packaging",
    description: "SLMG Beverages offers premium packaging solutions for the beverage industry, ensuring product quality and consumer satisfaction.",
    image: img19,
    isFeatured: true,
    displayOrder: 69
  },

  {
    id: 21,
    title: "Sonnex",
    slug: "sonnex",
    shortDescription: "Sonnex - Innovative packaging technology",
    description: "Sonnex provides innovative packaging technology and solutions for diverse industrial requirements.",
    image: img21,
    isFeatured: true,
    displayOrder: 70
  },

  {
    id: 22,
    title: "Srichakra",
    slug: "srichakra",
    shortDescription: "Srichakra - Comprehensive packaging solutions",
    description: "Srichakra offers comprehensive packaging solutions with a focus on sustainability and innovation.",
    image: img22,
    isFeatured: true,
    displayOrder: 71
  },

  {
    id: 20,
    title: "SRL Synthetics",
    slug: "srl-synthetics",
    shortDescription: "SRL Synthetics - Specialized synthetic materials",
    description: "SRL Synthetics specializes in the development and production of synthetic materials for various industrial applications.",
    image: img20,
    isFeatured: true,
    displayOrder: 72
  },

  {
    id: 56,
    title: "Sumilon",
    slug: "sumilon",
    shortDescription: "Sumilon - Chemical industry solutions",
    description: "Sumilon provides comprehensive solutions for the chemical industry with a focus on quality and innovation.",
    image: imgC21,
    isFeatured: true,
    displayOrder: 73
  },

  {
    id: 24,
    title: "Swastika",
    slug: "swastika",
    shortDescription: "Swastika - Industrial solutions provider",
    description: "Swastika provides comprehensive industrial solutions and services across various manufacturing sectors.",
    image: img24,
    isFeatured: true,
    displayOrder: 74
  },

  {
    id: 25,
    title: "Tarsons",
    slug: "tarsons",
    shortDescription: "Tarsons - Laboratory equipment manufacturer",
    description: "Tarsons is a leading manufacturer of laboratory equipment and plastic products for scientific and industrial applications.",
    image: img25,
    isFeatured: true,
    displayOrder: 75
  },

  {
    id: 23,
    title: "Temple Packaging",
    slug: "temple-packaging",
    shortDescription: "Temple Packaging - Quality packaging products",
    description: "Temple Packaging specializes in high-quality packaging products for various industries, with a focus on customer satisfaction.",
    image: img23,
    isFeatured: true,
    displayOrder: 76
  },

  {
    id: 69,
    title: "Torrent",
    slug: "torrent",
    shortDescription: "Torrent - Leading pharmaceutical company",
    description: "Torrent Pharmaceuticals is one of the leading pharmaceutical companies in India with a strong presence in both domestic and international markets.",
    image: img1,
    isFeatured: true,
    displayOrder: 77
  },

  {
    id: 43,
    title: "Transcom Bottlers Bangladesh",
    slug: "transcom-bottlers-bangladesh",
    shortDescription: "Transcom Bottlers Bangladesh - Transportation solutions",
    description: "Transcom Bottlers Bangladesh provides comprehensive transportation and logistics solutions with a focus on efficiency and reliability.",
    image: imgC8,
    isFeatured: true,
    displayOrder: 78
  },

  {
    id: 2003,
    title: "Uflex",
    slug: "uflex",
    shortDescription: "Uflex - Packaging solutions",
    description: "Uflex - added to customers list.",
    image: imgC33,
    isFeatured: true,
    displayOrder: 79
  },

  {
    id: 2007,
    title: "Varun Beverages",
    slug: "varun-beverages",
    shortDescription: "Varun Beverages - Beverage company",
    description: "Varun Beverages (Pepsi bottler) - added to customers list.",
    image: imgVarunVBL,
    isFeatured: true,
    displayOrder: 80
  },

  {
    id: 2,
    title: "VAS Engineering",
    slug: "vas-engineering",
    shortDescription: "VAS Engineering - Engineering solutions",
    description: "VAS Engineering provides comprehensive engineering solutions and services for various industrial applications.",
    image: img2,
    isFeatured: true,
    displayOrder: 81
  },

  {
    id: 27,
    title: "Vidyut",
    slug: "vidyut",
    shortDescription: "Vidyut - Electrical solutions provider",
    description: "Vidyut specializes in electrical solutions and services for industrial and commercial applications.",
    image: img27,
    isFeatured: true,
    displayOrder: 82
  },

  {
    id: 29,
    title: "Vishal Beverages Pvt Ltd",
    slug: "vishal-beverages-pvt-ltd",
    shortDescription: "Vishal Beverages Pvt Ltd - Beverage solutions",
    description: "Vishal Beverages Pvt Ltd offers beverage solutions and packaging support with a focus on quality and customer satisfaction.",
    image: imgVishalBeveragesPvtLtd,
    isFeatured: true,
    displayOrder: 83
  },

  {
    id: 50,
    title: "Zee Pack Angola",
    slug: "zee-pack-angola",
    shortDescription: "Zee Pack Angola - Advanced packaging technology",
    description: "Zee Pack Angola offers advanced packaging technology and solutions with a focus on innovation and environmental responsibility.",
    image: imgC15,
    isFeatured: true,
    displayOrder: 84
  }
]

export default customers;





